/* 🤖 this file was generated by svg-to-ts */
export const DfIconClockFilled12: {
  name: 'clock-filled-12';
  data: string;
} = {
  name: 'clock-filled-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0zm0 2a1 1 0 0 0-1 1v3a1.02 1.02 0 0 0 .125.484.878.878 0 0 0 .071.111l.014.018c.005.007.007.01.01.012l.073.082 2.002 2.009A1 1 0 1 0 8.71 7.302L7 5.586V3a1 1 0 0 0-.883-.993z" fill-rule="evenodd"/></svg>`
};
